export class ClsSMTPEmpresaModel {
    public SE_EMPRESA_ID: number
    public SE_CORREO: string
    public SE_CLAVE: string
    public SE_SMTP_ID: number
    public SE_IP_EQUIPO: string
}
